import React from 'react';

import { Person as PersonIcon, Message as MessageIcon } from '@mui/icons-material';
import { Box, Typography, Chip } from '@mui/material';

import MessageWrapper from 'pages/Analysis/components/MessageWrapper';
import type { GetClientInfoToolArguments } from 'services/types/ticket';

interface Props {
  args: string;
}

const GetClientInfoToolComponent: React.FC<Props> = ({ args }) => {
  let parsedArgs: GetClientInfoToolArguments;

  try {
    parsedArgs = JSON.parse(args) as GetClientInfoToolArguments;
  } catch (error) {
    return (
      <MessageWrapper caption="Herramienta de Cliente" align="left">
        <Typography color="error">Error al parsear argumentos: {args}</Typography>
      </MessageWrapper>
    );
  }

  return (
    <MessageWrapper caption="Obtener información de cliente" align="left">
      <Box>
        <Box mb={1}>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            <PersonIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'text-bottom' }} />
            ID del cliente:
          </Typography>
          <Chip
            label={`Cliente #${parsedArgs.clientId}`}
            size="small"
            color="primary"
            sx={{ fontFamily: 'monospace' }}
          />
        </Box>

        <Box mb={1}>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            Información a incluir:
          </Typography>
          <Box display="flex" gap={1} flexWrap="wrap" mt={0.5}>
            <Chip label="Datos básicos del cliente" size="small" variant="outlined" />
            {parsedArgs.includeMessages ? (
              <Chip label="Historial de mensajes" size="small" color="secondary" icon={<MessageIcon />} />
            ) : (
              <Chip label="Sin mensajes" size="small" variant="outlined" />
            )}
          </Box>
        </Box>

        <Typography variant="body2" color="text.secondary">
          Consultando información del cliente con filtros de unidad de negocio...
        </Typography>
      </Box>
    </MessageWrapper>
  );
};

export default GetClientInfoToolComponent;
